import { Separator } from "@/components/ui/separator";
import AllCategoriesMenu from "./AllCategories";
import Link from "next/link";
import { paths } from "@/app/constant";

const menuList = [
  { label: "Shop", link: paths.products },
  { label: "iPads", link: paths.products },
  { label: "Laptops", link: paths.products },
  { label: "Smartphones", link: paths.products },
  { label: "Cameras", link: paths.products },
  { label: "Headphones", link: paths.products },
];

const menuList2 = [
  { label: "About us", link: paths.aboutUs },
  { label: "Contact us", link: paths.contactUs },
  { label: "Services", link: paths.services },
];

export default function Menu({ categoryList }) {
  return (
    <div className="flex justify-between w-full  items-center">
      <ul className="flex justify-between  leading-[29px] w-full mr-3 ">
        {/*<li className=" w-[135px]  mr-2 hoverunderline ">
          <AllCategoriesMenu />
        </li> */}
        <li className=" cursor-pointer text-center wireless-Medium">
          <Link href={`/products?page=1&categories=all `} className="hoverunderline">
            Shop
          </Link>
        </li>
        {categoryList?.categories?.map((item, index) => {
          if (item?.ordering_number && item?.ordering_number <= 5) {
            return (
              <li key={index} className="cursor-pointer text-center wireless-Medium truncate mx-2  ">
                <Link
                  title={item.category_name}
                  href={`/products?Category=${item.category_name}`}
                  className="hoverunderline"
                >
                  {item.category_name}
                </Link>
              </li>
            );
          }
          return null;
        })}
        {/* */}

        <li className="w-[2px]">
          <Separator orientation="vertical" className="w-[1px] h-[29px] rounded bg-midnightIndigo-350 opacity-20" />
        </li>
        {menuList2.map((item, index) => (
          <li key={item + index} className="cursor-pointer wireless-Medium  text-center  truncate">
            <Link href={item.link} className="hoverunderline ">
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
